import {
  INVALID_PARAM_ERROR,
  TAX_ERROR,
  TERMS_ACCEPTED_FIELD,
} from 'constants/index';
import type { ErrorModel } from 'models';
import type { RootState } from 'reducers/types';

export const getErrors = (state: RootState) => {
  const { errors: { params = [] } = {} } = state;

  return params;
};

export const getInvalidParamErrors = (state: RootState) => {
  const { errors: { byParam = {}, params = [] } = {} } = state;

  const invalidParamErrors = params.reduce((acc: ErrorModel[], param) => {
    const error = byParam[param];

    if (error.type === INVALID_PARAM_ERROR) {
      acc = [...acc, { ...error, param }];
    }

    return acc;
  }, []);

  return invalidParamErrors;
};

export const hasTermsError = state => {
  const errors = getErrors(state);

  return errors.includes(TERMS_ACCEPTED_FIELD);
};

export const isThereAnErrorRetrievingTaxes = state => {
  const { errors: { byParam = {} } = {} } = state;
  const offerPanNumberError = byParam.offer_pan_number;

  return offerPanNumberError?.type === TAX_ERROR;
};

export const getPaymentItemError = state => {
  const { byParam = {} } = state.errors;

  return byParam.payment_item;
};

export const hasDuplicatedPaymentParamError = (state: RootState) => {
  const { errors: { byParam = {} } = {} } = state;
  const offerPanNumberError = byParam.offer_pan_number;

  return offerPanNumberError?.type === 'duplicated_payment_error';
};
